import { render, staticRenderFns } from "./TargetCampaignHealthPanel.vue?vue&type=template&id=63038b90&scoped=true"
import script from "./TargetCampaignHealthPanel.vue?vue&type=script&lang=js"
export * from "./TargetCampaignHealthPanel.vue?vue&type=script&lang=js"
import style0 from "./TargetCampaignHealthPanel.vue?vue&type=style&index=0&id=63038b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63038b90",
  null
  
)

export default component.exports